/**
 * @generated SignedSource<<a003bbf40d782f52bb06219bf72e167b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer" | "PdpRespSharedAboutItemPanel_viewer" | "getPdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespDetailTabs_viewer";
};
export type PdpRespDetailTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getPdpEstimateSimilarSold_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getHasEnoughSimilarSoldItems_viewer",
          "selections": [
            {
              "condition": "isEstimateSimilarSoldVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "similarSoldItemsResults",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 0
                    },
                    {
                      "kind": "Variable",
                      "name": "itemId",
                      "variableName": "itemId"
                    }
                  ],
                  "concreteType": "SimilarSoldItemsConnection",
                  "kind": "LinkedField",
                  "name": "similarSoldItems",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalResults",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "isEstimateSimilarSoldVariant"
            },
            {
              "kind": "RootArgument",
              "name": "itemId"
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ab24178c482fd92d4d6340b84a60c267";

export default node;
